import Component from './component.jsx'
export default Component
